import React from 'react';

import { CarOutlined, HomeOutlined, InboxOutlined } from '@ant-design/icons';
import { GlobalToken, theme, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { Module } from '@app/models/users';

const MODULE_ICONS: Record<Module, React.ReactNode> = {
  [Module.Warehouse]: <HomeOutlined />,
  [Module.Delivery]: <CarOutlined />,
  [Module.Supply]: <InboxOutlined />,
};

const moduleColors = (module: Module, token: GlobalToken) =>
  ({
    [Module.Warehouse]: { background: token.colorPrimaryBg, color: token.colorPrimary },
    [Module.Delivery]: { background: token.colorWarningBg, color: token.colorWarningText },
    [Module.Supply]: { background: token.colorSuccessBg, color: token.colorSuccessText },
  }[module]);

const isModule = (value: string): value is Module => Object.values(Module).includes(value as Module);

interface IProps {
  module: string;
}

export const ModuleIcon: React.FC<IProps> = ({ module }) => {
  const { token } = theme.useToken();
  const commonT = useTranslation(NSKeys.common);

  if (!isModule(module)) {
    return null;
  }

  const label = commonT.t(`module.${module}` as const);

  return (
    <Tooltip title={label}>
      <span
        role="img"
        aria-label={label}
        style={{
          display: 'inline-flex',
          width: 24,
          height: 24,
          flex: 'none',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 6,
          ...moduleColors(module, token),
        }}
      >
        {MODULE_ICONS[module]}
      </span>
    </Tooltip>
  );
};
